import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1)
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_7 = { class: "DialogSection" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1)
const _hoisted_9 = {
  id: "D_Profiles_Print",
  class: "DialogSection"
}
const _hoisted_10 = {
  class: "CookiesButton",
  style: {"margin":"0.5em"}
}
const _hoisted_11 = { class: "F-Bold F1_25em D-Flex" }
const _hoisted_12 = {
  class: "JustPrint",
  style: {"padding-inline-end":"0.5em"}
}
const _hoisted_13 = { class: "JustPrint" }
const _hoisted_14 = { class: "NOPRINT" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "BGGreen Rad2 F_85em",
  style: {"padding":"0.1em 0.6em","margin-inline-start":"0.5em"}
}
const _hoisted_18 = {
  key: 1,
  class: "BGMain Rad2 F_85em",
  style: {"padding":"0.1em 0.6em","margin-inline-start":"0.5em"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_20 = { class: "DialogSection" }
const _hoisted_21 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_22 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CookiesImageInput, {
              Folder: 'Catalogs',
              Res: 'D_Catalog_Image',
              style: {"border-radius":"var(--rad1)","width":"80%","height":"12em"}
            })
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Catalog Name'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Catalog_Name') && _ctx.MEMRead('D_Catalog_Name') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Catalog_Name') && _ctx.MEMRead('D_Catalog_Name') !== ''),
              Res: 'D_Catalog_Name',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"])
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.EditCategories())),
              class: "W-100",
              style: {"text-align":"end"}
            }, [
              _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.Translate('Edit Catgoies')), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.MEMRead('D_Catalog_Name')), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.Translate('Catalog')), 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.Translate('Items')), 1)
            ]),
            _hoisted_15,
            (!(_ctx.Loading.length > 0))
              ? (_openBlock(), _createBlock(_component_CookiesTable, {
                  key: 0,
                  onCustomSorting: _ctx.CustomSorting,
                  onEditItem: _ctx.EditItem,
                  onDeleteRow: _ctx.RemoveItem,
                  class: "Shadow1",
                  TableSettings: _ctx.TableSettings,
                  CookiesData: _ctx.MEMRead('D_Catalog_Items'),
                  Search: '',
                  Loading: _ctx.Loading.length
                }, {
                  default: _withCtx(({ field, element }) => [
                    ((field as CookiesTableField).Name === 'Code')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          ((element as CatalogItem).IsNew)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "New"))
                            : _createCommentVNode("", true),
                          ((element as CatalogItem).IsEdited)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Edited"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["onCustomSorting", "onEditItem", "onDeleteRow", "TableSettings", "CookiesData", "Loading"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.AddItem())),
                class: "CookiesButton BGMain F-Bold"
              }, [
                _createVNode(_component_CookiesIcon, {
                  class: "M-Auto SQR1_5em",
                  style: {"padding-inline-end":"0.5em"},
                  ID: 'Add'
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Add Item')), 1)
              ])
            ])
          ])
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Catalogue_Edit': 'Catalogue_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Save')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}